import React from 'react';
import { ShieldCheck, User } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

interface HandoffScreenProps {
  orderId: string;
  driverName: string;
  driverPhotoUrl?: string;
  pickupCode: string;
}

export function HandoffScreen({ orderId, driverName, driverPhotoUrl, pickupCode }: HandoffScreenProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4 text-center space-y-8 bg-gray-50 rounded-3xl">
      
      {/* Driver Info */}
      <div className="space-y-4">
        <div className="relative mx-auto h-24 w-24 rounded-full bg-gray-200 overflow-hidden border-4 border-white shadow-lg">
          {driverPhotoUrl ? (
            <img src={driverPhotoUrl} alt={driverName} className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full items-center justify-center">
              <User className="h-10 w-10 text-gray-400" />
            </div>
          )}
        </div>
        <div>
          <h2 className="text-2xl font-serif font-bold text-heading">{driverName}</h2>
          <p className="text-body font-medium">is arriving for Order #{orderId.slice(-4)}</p>
        </div>
      </div>

      {/* Verification Code */}
      <Card className="w-full max-w-sm border-2 border-primary/20 shadow-xl bg-white">
        <CardContent className="p-8">
          <p className="text-sm font-medium text-body mb-2 uppercase tracking-widest">Pickup Code</p>
          <div className="text-6xl font-mono font-bold text-primary tracking-[0.5em] pl-[0.25em]">
            {pickupCode}
          </div>
        </CardContent>
      </Card>

      {/* Instruction */}
      <div className="flex items-center space-x-2 text-warning bg-warning/10 px-4 py-2 rounded-lg">
        <ShieldCheck className="h-5 w-5" />
        <span className="font-medium text-sm">Verify code with courier before handing over goods</span>
      </div>
    </div>
  );
}

